import styled from "@emotion/styled";
import { Text } from "../../../components/general/Text";
import React from "react";
import { withIsVisible } from "../../../utils/reactUtils";
import { Amount } from "../../../types/amount";
import { FlexContainer } from "../../../containers/FlexContainer";

export interface TotalTradeAmountProps {
  totalUsdAmount: Amount;
}
export const TotalTradeAmount = withIsVisible(({ totalUsdAmount }: TotalTradeAmountProps) => {
  return (
    <TotalTradeAmountContainer>
      <Text size={"Medium"} textStyle={"Title"}>
        Total
      </Text>
      <Text size={"Medium"} textStyle={"Title"}>
        ${totalUsdAmount.format(2)}
      </Text>
    </TotalTradeAmountContainer>
  );
});

const TotalTradeAmountContainer = styled(FlexContainer)`
  gap: 8px;
  justify-content: end;
  align-self: stretch;
  color: ${props => props.theme.font.secondary.default};
`;
